import { render, staticRenderFns } from "./m-observation.html?vue&type=template&id=35d34713&scoped=true&external"
import script from "./m-observation.js?vue&type=script&lang=js&external"
export * from "./m-observation.js?vue&type=script&lang=js&external"
import style0 from "./m-observation.scss?vue&type=style&index=0&id=35d34713&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d34713",
  null
  
)

export default component.exports